import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabfare() {



  const cardData = {
"keyword": "Pune Cab Fare",

"headingDescription":
  "Shivai Travels offers transparent and affordable Pune Cab Fare options for local travel, airport transfers, outstation trips, business rides, family outings, and daily commuting. We focus on providing budget-friendly taxi services with clear pricing, no hidden charges, professional drivers, and comfortable vehicles to ensure a smooth travel experience. Whether you need a one-way ride, round-trip cab, airport pickup, or full-day taxi booking, our Pune cab fare plans are designed to suit every budget and travel requirement. Shivai Travels provides air-conditioned sedans, spacious SUVs, and premium cars with easy online booking and 24/7 customer support for reliable and convenient transportation across Pune and nearby destinations.",

"topPlaces": [
  {
    "title": "Pune Local Cab Fare Per KM",
    "description": "Pune cab fare for local travel is usually calculated per kilometer, making it suitable for short city rides, office commute, shopping trips, and daily transportation needs with transparent pricing."
  },
  {
    "title": "Airport Cab Fare in Pune",
    "description": "Pune airport cab fare depends on distance and vehicle type, offering fixed or per-km pricing for pickup and drop services to and from Pune Airport with comfortable travel options."
  },
  {
    "title": "Outstation Cab Fare from Pune",
    "description": "Outstation cab fare from Pune varies based on destination like Mumbai, Goa, Nashik, Shirdi, and Mahabaleshwar, with per-km pricing and round-trip or one-way options."
  },
  {
    "title": "One Way Cab Fare Pune",
    "description": "One-way cab fare in Pune is designed for intercity travel without return charges, making it a cost-effective option for long-distance trips with flexible pricing models."
  },
  {
    "title": "Hourly Cab Rental Fare Pune",
    "description": "Hourly cab fare in Pune allows customers to hire a taxi for a fixed number of hours, ideal for meetings, errands, and multiple-stop city travel at affordable rates."
  },
  {
    "title": "SUV and Sedan Cab Fare Pune",
    "description": "Cab fare in Pune varies by vehicle type, with sedans like Dzire and Etios offering economical pricing and SUVs like Innova and Ertiga providing premium comfort at higher rates."
  },
  {
    "title": "Night Cab Fare in Pune",
    "description": "Night cab fare in Pune may include small surcharges depending on time and distance, ensuring safe and reliable travel during late-night hours across the city."
  },
  {
    "title": "Corporate Cab Fare Pune",
    "description": "Corporate cab fare in Pune is designed for business travel with flexible billing options, monthly packages, and reliable transportation for employees and meetings."
  },
  {
    "title": "Group Travel Cab Fare Pune",
    "description": "Group cab fare in Pune is cost-efficient for families and friends traveling together in larger vehicles like Innova, Ertiga, and Tempo Traveller."
  },
  {
    "title": "Transparent Taxi Pricing Pune",
    "description": "Pune cab fare is generally transparent and based on distance, time, and vehicle type, ensuring fair pricing without hidden charges for customers."
  }
],



services: [
  {
    name: "Pune Cab Fare",
    description: "Pune cab fare service provides transparent pricing information for passengers planning local and outstation travel within Pune and nearby destinations. Travelers can estimate transportation costs based on vehicle type, distance, and travel requirements. Comfortable vehicles ensure smooth city and highway travel experience for passengers. Professional drivers provide safe driving and punctual pickup services throughout the journey. Flexible booking options allow convenient fare estimation and cab reservations."
  },
  {
    name: "Taxi Fare Pune",
    description: "Taxi fare Pune service helps passengers understand travel pricing for local rides, airport transfers, and outstation journeys from Pune. Comfortable vehicles provide reliable transportation suitable for families, tourists, and business travelers. Professional drivers ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy fare planning and taxi reservations."
  },
  {
    name: "Cab Charges Pune",
    description: "Cab charges Pune service provides clear pricing details for passengers traveling within Pune city and nearby destinations. Travelers can estimate travel expenses based on distance, vehicle category, and trip duration. Comfortable vehicles ensure smooth city and highway journeys with experienced drivers ensuring passenger safety. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient travel cost estimation and cab reservations."
  },
  {
    name: "Pune Taxi Price",
    description: "Pune taxi price service offers fare estimation for local travel, airport transfers, and outstation trips from Pune. Comfortable vehicles provide reliable transportation suitable for city and highway travel requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow passengers to estimate taxi pricing conveniently."
  },
  {
    name: "Cab Fare Calculator Pune",
    description: "Cab fare calculator Pune service helps passengers estimate transportation costs for local and outstation travel from Pune. Travelers can calculate approximate fare based on travel distance, vehicle type, and trip requirements. Comfortable vehicles provide smooth travel experience for airport transfers, tourism, and business travel. Professional drivers ensure safe journeys and punctual pickup services. Flexible booking options allow convenient fare calculation and cab reservations."
  },
  {
    name: "Pune Cab Rates Per KM",
    description: "Pune cab rates per km service provides pricing information for passengers planning local and outstation taxi journeys from Pune. Travelers can estimate travel expenses based on kilometer usage and vehicle category selection. Comfortable vehicles ensure reliable transportation with professional drivers offering safe driving services. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient travel planning and cab reservations."
  },
  {
    name: "Outstation Cab Fare Pune",
    description: "Outstation cab fare Pune service provides transparent pricing details for long-distance travel from Pune to tourist destinations, business cities, and pilgrimage locations. Vehicles include sedans, SUVs, and premium taxis suitable for comfortable highway travel. Professional drivers ensure safe driving and smooth journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation fare estimation and cab reservations."
  },
  {
    name: "Local Cab Fare Pune",
    description: "Local cab fare Pune service helps passengers estimate pricing for city travel, shopping trips, office commutes, and airport transfers within Pune. Comfortable vehicles provide smooth city travel experience suitable for daily transportation needs. Professional drivers ensure safe journeys and timely pickup services across Pune. Pickup services are available from homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient fare estimation and local cab reservations."
  },
  {
    name: "Pune Airport Cab Fare",
    description: "Pune airport cab fare service provides transparent pricing information for airport pickup and drop transportation in Pune. Comfortable vehicles ensure smooth airport travel with spacious seating and luggage space suitable for travelers. Professional drivers ensure punctual airport pickup and safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Pune. Flexible booking options allow convenient airport fare estimation and cab reservations."
  },
  {
    name: "One Way Cab Fare Pune",
    description: "One way cab fare Pune service offers pricing details for passengers planning one-way travel from Pune to local and outstation destinations. Comfortable vehicles provide reliable transportation suitable for airport transfers, business trips, tourism, and family visits. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient one-way fare planning and cab reservations."
  },
  {
    name: "Round Trip Cab Fare Pune",
    description: "Round trip cab fare Pune service provides pricing information for passengers planning return journeys from Pune to nearby cities and tourist destinations. Comfortable vehicles ensure smooth city and highway travel with experienced drivers ensuring safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, family trips, and tourism. Flexible booking options allow convenient round-trip fare estimation and cab reservations."
  },
  {
    name: "Cheapest Cab Fare Pune",
    description: "Cheapest cab fare Pune service provides affordable pricing information for passengers looking for economical transportation within Pune and nearby destinations. Comfortable vehicles ensure reliable city and highway travel while maintaining budget-friendly pricing options. Professional drivers ensure safe journeys and punctual pickup services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient low-cost cab fare estimation and reservations."
  },
  {
    name: "Cab Price Estimate Pune",
    description: "Cab price estimate Pune service helps travelers calculate approximate transportation costs for local and outstation journeys from Pune. Comfortable vehicles provide reliable travel suitable for airport transfers, office travel, and tourism trips. Professional drivers ensure safe driving and smooth travel experience for passengers. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient price estimation and cab reservations."
  },
  {
    name: "Taxi Rate Pune City",
    description: "Taxi rate Pune city service provides fare details for local transportation across Pune city and nearby areas. Comfortable vehicles ensure smooth city travel suitable for daily commutes, airport transfers, shopping trips, and business travel. Professional drivers ensure punctual pickup and safe transportation services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient city taxi fare estimation and reservations."
  },
  {
    name: "Affordable Cab Fare Pune",
    description: "Affordable cab fare Pune service provides economical pricing options for passengers looking for budget-friendly transportation within Pune and nearby destinations. Comfortable vehicles ensure reliable travel experience while maintaining affordable fare structures. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient affordable fare estimation and cab reservations."
  },
  {
    name: "Pune to Mumbai Cab Fare",
    description: "Pune to Mumbai cab fare service provides transparent pricing details for passengers planning travel between Pune and Mumbai. Comfortable vehicles ensure smooth expressway travel with professional drivers offering safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for business travel, airport transfers, tourism, and family visits. Flexible booking options allow convenient fare estimation and cab reservations."
  }
],

tableData: [
  ["Pune Cab Fare", "Taxi Fare Pune"],
  ["Cab Charges Pune", "Pune Taxi Price"],
  ["Cab Fare Calculator Pune", "Pune Cab Rates Per KM"],
  ["Outstation Cab Fare Pune", "Local Cab Fare Pune"],
  ["Pune Airport Cab Fare", "One Way Cab Fare Pune"],
  ["Round Trip Cab Fare Pune", "Cheapest Cab Fare Pune"],
  ["Cab Price Estimate Pune", "Taxi Rate Pune City"],
  ["Affordable Cab Fare Pune", "Pune to Mumbai Cab Fare"]
],



 whychoose: [
      {
        WhyChooseheading: "Affordable Pune Cab Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune cab fare for local travel, airport transfers, and outstation trips. Customers receive budget-friendly taxi pricing with transparent fare details before booking confirmation."
      },
      {
        WhyChooseheading: "Transparent Fare Without Hidden Charges",
        WhyChoosedescription: "Shivai Travels provides clear Pune cab fare information including toll charges, parking fees, and driver allowances wherever applicable to ensure complete pricing transparency."
      },
      {
        WhyChooseheading: "24/7 Taxi Service at Competitive Fare",
        WhyChoosedescription: "Our Pune cab service is available 24 hours a day with competitive fare options for airport pickup, railway station transfer, local city rides, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable AC Cabs at Reasonable Pricing",
        WhyChoosedescription: "Shivai Travels provides clean, sanitized, and air-conditioned taxis at economical Pune cab fare rates for comfortable and safe travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Way & Round Trip Fare Plans",
        WhyChoosedescription: "Customers can choose flexible travel options including one-way taxi fare, round-trip packages, airport transfer pricing, and customized outstation cab fare plans from Pune."
      },
      {
        WhyChooseheading: "Multiple Vehicle Options for Every Budget",
        WhyChoosedescription: "Shivai Travels offers different vehicle categories including sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers with fare options suitable for every travel requirement and budget."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune City",
        WhyChoosedescription: "Shivai Travels provides convenient pickup services from homes, offices, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Reliable Taxi Service with Fair Pricing",
        WhyChoosedescription: "Shivai Travels is trusted for reliable Pune taxi services with fair cab fare, professional drivers, punctual pickups, comfortable vehicles, and smooth travel experiences."
      }
    ]
  };

  const faqData = [
    { question: "What is the Pune cab fare?", answer: "Pune cab fare depends on the vehicle type, travel distance, and travel plan selected. Shivai Travels offers affordable and transparent pricing." },
    { question: "Is Pune cab fare affordable for local travel?", answer: "Yes, Shivai Travels provides budget-friendly Pune cab fare for local city travel and airport transfers." },
    { question: "Are toll charges included in Pune cab fare?", answer: "Fare details may vary depending on the trip. Shivai Travels provides complete fare information before booking confirmation." },
    { question: "Do you provide one-way taxi fare options?", answer: "Yes, Shivai Travels provides one-way as well as round-trip taxi fare plans from Pune." },
    { question: "Is Pune airport taxi fare available 24/7?", answer: "Yes, Shivai Travels provides 24/7 airport taxi service with affordable fare options." },
    { question: "Which vehicles are available for Pune taxi service?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a taxi online in Pune?", answer: "Yes, customers can easily book Pune taxi services online or through phone booking." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis provided by Shivai Travels are fully air-conditioned and well maintained." },
    { question: "Do you provide outstation taxi fare packages?", answer: "Yes, Shivai Travels provides affordable outstation cab fare packages from Pune." },
    { question: "Is advance booking available for Pune taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Sachin More",
      feedback:
        "Affordable Pune cab fare with excellent service from Shivai Travels. Clean cab and professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Rutuja Patil",
      feedback:
        "Booked Pune airport taxi at reasonable fare. Smooth travel experience and transparent pricing.",
      rating: 5
    }
  ];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Cab Fare",
  "image": "https://shivaitravels.com/assets/images/pune-cab-fare.jpg",
  "description": "Check affordable Pune cab fare for local and outstation travel with Shivai Travels. Get budget-friendly taxi rates for Pune to Mumbai, Shirdi, Bhimashankar, airport transfers, one-way trips, and round-trip cab booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-cab-fare"
  }
};









  return (
    <div>
<Helmet>
  <title>Pune Cab Fare | Affordable Taxi Rates & Cab Charges | +91 9689815477</title>

  <meta
    name="description"
    content="Check Pune cab fare for local and outstation taxi booking. Affordable cab charges for Pune to Mumbai, Shirdi, Bhimashankar, airport transfers, one-way and round-trip travel."
  />

  <meta
    name="keywords"
    content="pune cab fare, taxi fare pune, cab charges pune, pune taxi price, cab fare calculator pune, pune cab rates per km, outstation cab fare pune, local cab fare pune, pune airport cab fare, one way cab fare pune, round trip cab fare pune, cheapest cab fare pune, cab price estimate pune, taxi rate pune city, affordable cab fare pune, Pune to shirdi cab charges, Pune to shirdi cab fare, Pune to mumbai airport cab fare, Pune to mumbai cab fare, pune to mumbai cab charges, pune to bhimashankar taxi fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punecabfare;